export default __webpack_public_path__ + "static/media/greenhouse.48882aaf.png";